export default {
    backendUrl: "https://newpmt.brigosha.com",
    socketUrl: "https://testibelong.brigosha.com"
}
// https://testibelong.brigosha.com
// dusted

